import { Component, OnInit } from '@angular/core';
import { SeoService } from './service/config/seo.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [SeoService]
})
export class AppComponent implements OnInit {
  constructor(private seoService: SeoService) { }
  ngOnInit(): void {
    this.seoService.updateSeo();   // Carga y aplica la config al iniciar
  }
  title = 'Utushop';
}
